<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.thx_modal
    +e.close-popup.js-close(@click='$emit("close")')
    +e.text-content
      +b.g-row--appearance_column
        +b.el
          +b.P.ds-caption--size_4xl-md.--size_xl.--w_r.--c_white.--h_180.tac
            | {{message.title}}
        +b.el--p_t_sm
          +b.P.ds-caption--size_1md-md.--size_10xs.--w_l.--c_white.--h_200.tac
            | {{message.text}}

</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/Modals/ModalAnswer.vue